// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__5mXp6","inputWrap":"Table_inputWrap__pH4JF","col":"Table_col__h6um1","bmiTooltip":"Table_bmiTooltip__3hqhm"};